import { Flex, Text } from '@frontend/legacy-components';

import { ViewerControlsInfoRow } from 'modules/common/viewer/components/ViewerControlsInfoRow';

/**
 * 2D viewer controls (DXF/DWG files) — body only; popover title is shared with 3D.
 */
export const Controls2DRows = ({ isMobile }: { isMobile: boolean }) => (
  <Flex direction="column" gap={0.5} minW="260px">
    <ViewerControlsInfoRow
      title="Zoom:"
      value={isMobile ? 'Pinch' : 'Scroll'}
    />
    <ViewerControlsInfoRow
      title="Pan:"
      value={isMobile ? 'Drag finger' : 'Drag RMB'}
    />
    <ViewerControlsInfoRow title="Rotate:" value="Use rotate buttons" />
    <ViewerControlsInfoRow
      title="Reset view:"
      value={isMobile ? 'Double tap' : 'Double-click or reset button'}
    />
  </Flex>
);
Controls2DRows.displayName = 'Controls2DRows';

/**
 * 3D viewer controls (STEP, STL, etc.) — body only; popover title is shared with 2D.
 */
export const Controls3DBody = ({ isMobile }: { isMobile: boolean }) => (
  <Flex direction="column" gap={0.5} minW="260px">
    <ViewerControlsInfoRow
      title="Zoom:"
      value={isMobile ? 'Slide fingers apart' : 'Scroll'}
    />
    <ViewerControlsInfoRow
      title="Rotate:"
      value={isMobile ? 'Drag finger' : 'Drag LMB'}
    />
    {!isMobile && <ViewerControlsInfoRow title="Pan:" value="Drag RMB" />}
    <ViewerControlsInfoRow
      title="Recenter trackball:"
      value={isMobile ? 'Double tap on body' : 'Double-click on body'}
    />

    <Text fontWeight="heavy" fontSize="md" lineHeight="short" mt={0.5} mb={0}>
      3D space actions
    </Text>

    <ViewerControlsInfoRow
      title="Zoom to fit:"
      value={isMobile ? 'Long press on body' : 'Right-click on body'}
    />
    <ViewerControlsInfoRow
      title="View normal to:"
      value={isMobile ? 'Long press on plane' : 'Right-click on plane'}
    />
    <ViewerControlsInfoRow
      title="Create selection:"
      value={
        isMobile
          ? 'Long press on entity (when no selected entities)'
          : 'Right-click on entity (when no selected entities)'
      }
    />
    <ViewerControlsInfoRow
      title="Zoom to selection:"
      value={
        isMobile
          ? 'Long press anywhere (when selected entities)'
          : 'Right-click anywhere (when selected entities)'
      }
    />
    <ViewerControlsInfoRow
      title="Clear selection:"
      value={
        isMobile
          ? 'Long press anywhere (when selected entities)'
          : 'Right-click anywhere (when selected entities)'
      }
    />
    <ViewerControlsInfoRow
      title="Focus:"
      value={isMobile ? 'Long press on body' : 'Right-click on body'}
    />
    <ViewerControlsInfoRow
      title="Isolate body:"
      value={isMobile ? 'Long press on body' : 'Right-click on body'}
    />
    <ViewerControlsInfoRow
      title="Hide body:"
      value={isMobile ? 'Long press on body' : 'Right-click on body'}
    />
    <ViewerControlsInfoRow
      title="Show all bodies:"
      value={isMobile ? 'Long press anywhere' : 'Right-click anywhere'}
    />
  </Flex>
);
Controls3DBody.displayName = 'Controls3DBody';
